import React from 'react';
import classNames from 'classnames';
import UploadingFile from './components/UploadingFile';
import { UploaderMessageFile } from 'hooks/useUploadMessageFile';

import './UploadingFiles.styles.scss';

type UploadingFilesProps = {
  className?: string;
  files: UploaderMessageFile[];
  onRemove: (id: string) => void;
};

const UploadingFiles: React.FC<UploadingFilesProps> = (props) => {
  const { className, files = [], onRemove } = props;

  const classes = classNames('uploading-files', className);

  return (
    <div className={classes}>
      {files.map((file) => (
        <UploadingFile
          key={file.name}
          file={file}
          onRemove={() => onRemove(file._id)}
        />
      ))}
    </div>
  );
};

export default UploadingFiles;
